import { Outlet } from "react-router-dom";
import Header from "./headers/Header";
import AdminHeader from "./headers/AdminHeader";
import PricingHeader from "./headers/PricingHeader";
import Footer from "./footer/footer";
import { isEmbedded } from "../utils/shoplineEmbedded";

const Layout = (props: { type: "admin" | "user" , page: "pricing" | ""}) => {
  return (
    <>
      {/* Inside SHOPLINE admin: no Ocesha website header (logo links, login/logout) */}
      {props.type === "admin" ? <AdminHeader /> : isEmbedded() ? null : props.page === "pricing"?<PricingHeader />:<Header />}
      <Outlet />
    </>
  );
};

export default Layout;
